export default (node) => {
  const playButton = node.querySelector('[data-play-button]');
  const pauseButton = node.querySelector('[data-pause-button]');
  const desktopVideo = node.querySelector('[data-desktop-video]');
  const mobileVideo = node.querySelector('[data-mobile-video]');

  const init = () => {
    node.addEventListener('click', (e) => {
      e.preventDefault();
      if (node.dataset.url && e.target.name !== 'button') {
        window.location.href = node.dataset.url;
      }
    });

    playButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (window.innerWidth >= 1024) {
        desktopVideo.play();
      } else {
        mobileVideo.play();
      }
      playButton.classList.add('hidden');
      pauseButton.classList.remove('hidden');
    });

    pauseButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (window.innerWidth >= 1024) {
        desktopVideo.pause();
      } else {
        mobileVideo.pause();
      }
      playButton.classList.remove('hidden');
      pauseButton.classList.add('hidden');
    });
  };

  init();
};
